import React, { useState } from 'react';
import { Card, CardBody, Collapse, Container } from 'reactstrap';
import Header from '../components/Header';
import MenuHeader from '../components/MenuHeader';
import Footer from '../components/Footer';

const FAQ = () => {
	const [collapse, setCollapse] = useState(true);
	const toggle = () => {
		setCollapse(!collapse);
	};
	return (
		<>
			<Header />
			<MenuHeader />
			<Container className='mt-2'>
				<Card className='shadow card__collapse__class'>
					<CardBody style={{ paddingLeft: 0, paddingRight: 0 }}>
						<div
							onClick={toggle}
							style={{ cursor: 'pointer', paddingLeft: '10px' }}
							className={` cursor-pointer font-weight-bold justify-content-center  p-2 ${
								collapse ? 'collapse__clicked' : ''
							}`}
						>
							{' '}
							Is it safe to purchase medications online?{' '}
							{/* <span className='text-end'>
								<i className='fas fa-arrow-down' />
							</span> */}
						</div>
						<hr />
						<Collapse isOpen={collapse}>
							<Card>
								<CardBody>
									Yes. We provide medications, both branded
									and generic, from the world's biggest
									pharmaceutical companies and wholesalers.
									Your privacy and security are important to
									us and will not be compromised.
									fastukmeds.com utilizes industry-standard
									security measures to make the order process
									and the transaction.
								</CardBody>
							</Card>
						</Collapse>
						<div
							onClick={toggle}
							style={{ cursor: 'pointer', paddingLeft: '10px' }}
							className={`font-weight-bold justify-content-center  p-2 ${
								collapse ? 'collapse__clicked' : ''
							}`}
						>
							{' '}
							Is fastukmeds.com a pharmacy?
						</div>
						<hr />
						<Collapse isOpen={collapse}>
							<Card>
								<CardBody>
									No, we are a pharmacy intermediary. We allow
									secure transactions between our customers
									and fully licensed pharmacies.
								</CardBody>
							</Card>
						</Collapse>
						<div
							onClick={toggle}
							style={{ cursor: 'pointer', paddingLeft: '10px' }}
							className={`font-weight-bold justify-content-center  p-2 ${
								collapse ? 'collapse__clicked' : ''
							}`}
						>
							{' '}
							Is it safe to use my credit card or debit card?
						</div>
						<hr />
						<Collapse isOpen={collapse}>
							<Card>
								<CardBody>
									Yes. fastukmeds.com uses the latest and most
									advanced online payments systems. Every
									precaution is taken to make sure that your
									transaction and details are fully secured.
								</CardBody>
							</Card>
						</Collapse>
						<div
							onClick={toggle}
							style={{ cursor: 'pointer', paddingLeft: '10px' }}
							className={`font-weight-bold justify-content-center  p-2 ${
								collapse ? 'collapse__clicked' : ''
							}`}
						>
							{' '}
							fastukmeds.com ships 99% of all orders for free
							worldwide using Registered Airmail (signature is
							required upon delivery). Only a small number of
							selected items are excluded. Visit our shipping
							policy page to learn more. Will the packaging be
							discrete?F
						</div>
						<hr />
						<Collapse isOpen={collapse}>
							<Card>
								<CardBody>
									Yes, only the shipping address and the
									return address appear on the package..
								</CardBody>
							</Card>
						</Collapse>
						<div
							onClick={toggle}
							style={{ cursor: 'pointer', paddingLeft: '10px' }}
							className={`font-weight-bold justify-content-center  p-2 ${
								collapse ? 'collapse__clicked' : ''
							}`}
						>
							{' '}
							What happens if I don't receive my order?
						</div>
						<hr />
						<Collapse isOpen={collapse}>
							<Card>
								<CardBody>
									Yes, only the shipping address and the
									return address appear on the package..
								</CardBody>
							</Card>
						</Collapse>
						<div
							onClick={toggle}
							style={{ cursor: 'pointer', paddingLeft: '10px' }}
							className={`font-weight-bold justify-content-center  p-2 ${
								collapse ? 'collapse__clicked' : ''
							}`}
						>
							{' '}
							How long does it take for my medications to arrive?
						</div>
						<hr />
						<Collapse isOpen={collapse}>
							<Card>
								<CardBody>
									Shipment varies from obe order to the next,
									depending on the shipping address, items
									ordered and the time of year (holidays).
								</CardBody>
							</Card>
						</Collapse>
						<div
							onClick={toggle}
							style={{ cursor: 'pointer', paddingLeft: '10px' }}
							className={`font-weight-bold justify-content-center  p-2 ${
								collapse ? 'collapse__clicked' : ''
							}`}
						>
							{' '}
							Can I check the status of my order?
						</div>
						<hr />
						<Collapse isOpen={collapse}>
							<Card>
								<CardBody>
									Yes, you can check your order's status by
									going to our Order Status system and
									entering your email and the password that
									was sent to you in the order confirmation
									email.
								</CardBody>
							</Card>
						</Collapse>
						<div
							onClick={toggle}
							style={{ cursor: 'pointer', paddingLeft: '10px' }}
							className={`font-weight-bold justify-content-center  p-2 ${
								collapse ? 'collapse__clicked' : ''
							}`}
						>
							{' '}
							What are your operating hours?
						</div>
						<hr />
						<Collapse isOpen={collapse}>
							<Card>
								<CardBody>
									Our sales assistants are available Sunday to
									Friday, between 9 a.m. and 6 p.m. American
									Eastern Standard Time. Please note that we
									do not ship orders on weekends. An order
									that will be placed after Friday at 4 p.m.
									will be processed on Monday.
								</CardBody>
							</Card>
						</Collapse>
						<div
							onClick={toggle}
							style={{ cursor: 'pointer', paddingLeft: '10px' }}
							className={`font-weight-bold justify-content-center  p-2 ${
								collapse ? 'collapse__clicked' : ''
							}`}
						>
							{' '}
							What are generic drugs? Are they safe?
						</div>
						<hr />
						<Collapse isOpen={collapse}>
							<Card>
								<CardBody>
									Generic drugs are medications produced by
									pharmaceutical companies based on branded
									drugs, after their patent expires. Generic
									drugs are identical to branded drugs, under
									strict regulations of the Federal Drugs
									Administration (FDA).
								</CardBody>
							</Card>
						</Collapse>
						<div
							onClick={toggle}
							style={{ cursor: 'pointer', paddingLeft: '10px' }}
							className={`font-weight-bold justify-content-center  p-2 ${
								collapse ? 'collapse__clicked' : ''
							}`}
						>
							{' '}
							Generic drugs are as safe as branded drugs, have the
							same formula and provide the exact same effect. Why
							can't I find the medication I need?
						</div>
						<hr />
						<Collapse isOpen={collapse}>
							<Card>
								<CardBody>
									If you cannot find the medications you want,
									please contact our sales assistants and they
									will gladly assist you.
								</CardBody>
							</Card>
						</Collapse>
					</CardBody>
				</Card>
			</Container>
			<Footer />
		</>
	);
};

export default FAQ;
